export function calculatePercent(
	number: number,
	originalNumber: number,
): string {
	const rawChange = number - originalNumber;

	const percentageChange =
		100 * Math.abs(rawChange / ((number + originalNumber) / 2));

	const sign = rawChange >= 0 ? '+' : '-';

	return `${sign}${percentageChange.toFixed(2)}%`;
}

export function isChangePositive(number: number, originalNumber: number) {
	return number > originalNumber;
}
